import React, { Component } from 'react'
import { navbar, nav, navitem, menuitem, Dropdown, Col,Row, Button, NavDropdown,MenuItem ,Nav, NavItem} from 'react-bootstrap';
import { Router, Route, Link, IndexRoute, hashHistory, browserHistory, DefaultRoute, IndexLink } from 'react-router'
import Apropos from './about.jsx'
import Products from './produits.jsx'
import Service from './services.jsx'
import Temoignages from './testimonial.jsx'
import Partenaires from './partners.jsx'
import Awards from './chiffres.jsx'
import { fadeInUp } from 'react-animations';
import { flipInX } from 'react-animations';
import Radium, {StyleRoot} from 'radium';
import { Bounce, Shake } from 'react-motions'




class ScrollPage extends Component {
  render() {
    return (
    <div>   
     
                <Awards/>
                <Products/>
            {/*<Apropos/>*/}
                <Service/>
                <Partenaires/>
    </div>
    )
  }
}
export default ScrollPage;


// WEBPACK FOOTER //
// ./src/components/scrollpage.jsx